/*
 *   Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *   This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *   No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .directive('accFetchUrlAndNavigate', ['$window', '$http', function ($window, $http) {
        return {
            replace: true,
            transclude: true,
            template: '<a href ng-click="open()" ng-transclude></a>',
            scope: {
                accFetchUrlAndNavigate: '<',
                openInBlankTab: '<',
                afterNavigate: '&'
            },
            controller: ['$scope', function ($scope) {
                var loading = false;

                $scope.open = function () {
                    if (loading) return;

                    loading = true;

                    $http.get($scope.accFetchUrlAndNavigate)
                        .then(function (response) {
                            $window.open(response.data['url'], $scope.openInBlankTab ? '_blank' : '');
                            if(angular.isFunction($scope.afterNavigate)) {
                                $scope.afterNavigate();
                            }
                        })
                        .finally(function () {
                            loading = false;
                        })
                }
            }]
        }
    }]);
